import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFoods, viewFood } from '../Redux/foodSlice';
import { useNavigate } from 'react-router-dom';
import FullScreenLoader from '../Components/FullScreenLoader'
import Swal from 'sweetalert2';
import toast from 'react-hot-toast'

const ShowFoods = ({ showItems, category }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {user} = useSelector((state) => state.loginUser)
const BASE_URl = window.location.origin


  const handleViewFood = (item) => {
    dispatch(viewFood(item))
    navigate('/viewFood')
  }

  if (!showItems || !Array.isArray(showItems)) {
    return <p className="text-center text-gray-600 text-lg">We don’t have that yet.</p>;
  }

 

  const handelDeleteFood = async(item) => {
    const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
        });
        if(result.isConfirmed){
          setLoading(true)
          fetch(`${BASE_URl}/api/deletefood/${item._id}`, {
            method: 'DELETE',
            credentials: 'include',
          }).then((res) => res.json())
          .then((data) => {
            if(data&&data.sucess === true){
              dispatch(fetchFoods())
              setLoading(false)
              toast.success(data.messege)
            } else if(data && data.sucess === false) {
              setLoading(false)
              toast.error(data.messege)
            } 
          })
          .catch((error) => {
            setLoading(false)
            toast.error(error.messege||'Something Went Wrong')
          })
        }
    }

  return (
    <div className="container mx-auto p-6 mb-14">
      {loading?<FullScreenLoader/>:null}
      {/* Display Category Name */}
      {category && (
        <h2 className="text-2xl font-bold text-center mb-14 capitalize">{category}</h2>
      )}

      {showItems.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {showItems.map((item, i) => (
            <div key={i} className="bg-white shadow-lg rounded-2xl p-4">
              <img
                src={item.image.secure_url}
                alt={item.title}
                className="w-full h-40 object-contain rounded-lg"
              />
              <h3 className="mt-4 text-lg font-semibold">{item.title}</h3>
              <p className="text-gray-500">RS: {item.price}</p>
              <div>
              {user&&user.role === "Admin"?<button onClick={()=>{handelDeleteFood(item)}} className="mt-4 cursor-pointer w-full bg-red-400 text-white py-2 rounded-lg hover:bg-red-500 transition">
                Delete
              </button>:null}
              <button onClick={()=>{handleViewFood(item)}} className="mt-4 cursor-pointer w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition">
                View
              </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-600 text-lg">We don’t have that yet.</p>
      )}
    </div>
  );
};

export default ShowFoods;
